import axios from 'axios'

export const getCart = async () => {
  const { data } = await axios.get('/cart.js')
  return data
}

export const sanitize = (str = '') => {
  return str?.replace(/["']/g, '') || ''
}
